<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination } from 'swiper/modules'
import ModalSwiper from '@/Components/ModalSwiper.vue'
import { ArrowsPointingOutIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { ref } from 'vue'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const props = defineProps({
    images: {
        type: Object,
        required: true,
    },
})

const open_modal = ref(false)
const current_image_id = ref(0)

const openModal = (image_id) => {
    open_modal.value = true
    current_image_id.value = image_id
}
</script>

<template>
    <div class="h-full">
        <Swiper
            loop
            :watchSlidesProgress="true"
            :navigation="true"
            :pagination="true"
            :modules="[Navigation, Pagination]"
            :breakpoints="{
                100: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
            }"
            class="group"
        >
            <SwiperSlide
                v-for="image in images"
                :key="image.id"
                class="relative cursor-pointer selection:bg-transparent"
                @click="openModal(image.id)"
            >
                <div class="absolute right-2 top-2 z-50 size-10 overflow-hidden rounded-lg bg-black/50 group-hover:bg-black/60">
                    <ArrowsPointingOutIcon
                        class="faster-animation cursor-pointer p-1 text-white hover:p-0.5"
                        @click="open_modal = true"
                    />
                </div>

                <img
                    class="h-[18rem] w-full bg-black object-cover object-center md:h-[27em] lg:h-[36rem] xl:h-[40rem] xl:rounded-xl"
                    :src="'/storage/businesses/' + image.imageable_id + '/images/' + image.image"
                    :alt="image.image"
                />
            </SwiperSlide>
        </Swiper>
    </div>

    <ModalSwiper
        :show="open_modal"
        @close="open_modal = false"
        :images="images"
        :current_image_id="current_image_id"
        maxWidth="7xl"
        storageType="businesses"
    >
        <template #content>
            <button
                class="faster-animation absolute right-2 top-2 z-50 overflow-hidden rounded-lg bg-red-500 p-1 hover:bg-red-600"
                @click="open_modal = false"
            >
                <XMarkIcon class="size-7 text-white" />
            </button>
        </template>
    </ModalSwiper>
</template>
